import { FireMasterTheme, bonhamsTheme } from '@nx/fire/bonhams-theme-master'

import {
  ReactComponent as bonhamsSkinnerLogoIcon,
  default as bonhamsSkinnerLogoSVG,
} from './assets/bonhamsSkinnerLogo.svg'
import {
  ReactComponent as skinnerLogoIcon,
  default as skinnerLogoSVG,
} from './assets/skinnerLogo.svg'

export const skinnerTheme: FireMasterTheme = {
  ...bonhamsTheme,
  name: 'skinner',
  colours: {
    ...bonhamsTheme.colours,
    primary: {
      ...bonhamsTheme.colours.primary,
      primary: '#be1e2d',
    },
    secondary: {
      ...bonhamsTheme.colours.secondary,
      primary: '#9c1420',
    },
    tertiary: {
      ...bonhamsTheme.colours.tertiary,
      primary: '#f2eade',
    },
  },
  logo: {
    component: skinnerLogoIcon,
    svg: skinnerLogoSVG,
  },
  footerLogo: {
    component: bonhamsSkinnerLogoIcon,
    svg: bonhamsSkinnerLogoSVG,
  },
}
